import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';
import Icon from './Icon';
import semanticIcons from '@99designs/asimov/platform-settings/settings/semantic-icons';

export const SuccessStatusMessage = ({ children }) => (
    <div className="status-message--success">
        <Icon variations={[semanticIcons['success'], 'offset-right']} />
        <div>{children}</div>
    </div>
);

SuccessStatusMessage.propTypes = {
    children: PropTypes.node.isRequired,
};

export const WarningStatusMessage = ({ children }) => (
    <div className="status-message--warning">
        <Icon variations={[semanticIcons['warning'], 'offset-right']} />
        <div>{children}</div>
    </div>
);

WarningStatusMessage.propTypes = {
    children: PropTypes.node.isRequired,
};

export const ErrorStatusMessage = ({ children }) => (
    <div className="status-message--error">
        <Icon variations={[semanticIcons['error'], 'offset-right']} />
        <div>{children}</div>
    </div>
);

ErrorStatusMessage.propTypes = {
    children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/StatusMessages.jsx